// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"upload-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 19H20M7 9L12 4L17 9M12 15V5.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Upload1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'upload-1',
    ref,
    icon: element,
  },
));

Upload1Icon.displayName = 'Upload1Icon';

export default Upload1Icon;
